import React from 'react';
import { graphql } from 'gatsby';
import ProductSideBySide from './ProductSideBySide';
import { ProductPagePreview } from '../Global/DataUtils/productQueries';

import {
    KontentStringValue,
    KontentRadioMultiChoice,
    KontentRichText,
} from '../../../types/KontentProps';
import { ProductFamily } from '../../templates/StructuredDataContext';
import { getMultiChoice } from '../Global/DataUtils';

type contentDisplayType = 'explicit' | 'relative';
type layoutDisplayType = 'carousel' | 'stacked';
type productSelectionType = 'use_product_family_tag' | 'use_products_attached';

export interface ProductSideBySideProps {
    headline: KontentStringValue;
    description: KontentRichText;
    selection_for_product_display: KontentRadioMultiChoice<productSelectionType>;
    content_display_type: KontentRadioMultiChoice<contentDisplayType>;
    layout_display_type?: KontentRadioMultiChoice<layoutDisplayType>;
    products: { value: ProductPagePreview[] };
    product_family: { value: ProductFamily[] };
}

const ProductSideBySideContainer: React.FC<ProductSideBySideProps> = (
    props
) => {
    const selectProducts = (): ProductPagePreview[] => {
        let selectedProducts = [] as ProductPagePreview[];

        if (
            getMultiChoice(props.selection_for_product_display) ===
            'use_product_family_tag'
        ) {
            selectedProducts =
                props.product_family?.value[0]?.elements?.products?.value;
        } else {
            selectedProducts = props.products?.value;
        }

        return selectedProducts;
    };

    const content = selectProducts();

    return <ProductSideBySide {...props} content={content} />;
};

export default ProductSideBySideContainer;

export const fragmentProductSideBySide = graphql`
    fragment ProductSideBySide on kontent_item_component___product_side_by_side {
        elements {
            description {
                value
            }
            headline {
                value
            }
            selection_for_product_display {
                value {
                    codename
                }
            }
            product_family {
                value {
                    ... on kontent_item_data___product_family {
                        elements {
                            product_family {
                                name
                                value {
                                    codename
                                    name
                                }
                                taxonomy_group
                                type
                            }
                            products {
                                value {
                                    ...productPagePreview
                                }
                            }
                        }
                    }
                }
            }
            products {
                value {
                    ...productPagePreview
                }
            }
        }
    }
`;
